/* dusa: cart drawer/page extras
   - "Pairs well with": fetch Shopify product recommendations for the first cart item
   Idempotent by design: Dawn re-renders the whole drawer on cart updates, so a
   MutationObserver re-runs init whenever the drawer subtree is replaced. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initRecs(root) {
    (root || document).querySelectorAll('[data-dusa-recs]').forEach(function (el) {
      if (el.dataset.dusaLoaded) return;
      el.dataset.dusaLoaded = '1';
      var productId = el.getAttribute('data-product-id');
      var list = el.querySelector('[data-dusa-recs-list]');
      if (!productId || !list) return;
      var inCart = (el.getAttribute('data-cart-handles') || '').split(',');
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(
        rootUrl +
          'recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=6&intent=related'
      )
        .then(function (r) {
          if (!r.ok) throw new Error('recs ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var picks = (data.products || [])
            .filter(function (p) {
              return p.available && inCart.indexOf(p.handle) === -1;
            })
            .slice(0, 3);
          if (!picks.length) {
            el.hidden = true;
            return;
          }
          list.textContent = '';
          picks.forEach(function (p) {
            var a = document.createElement('a');
            a.className = 'dusa-rec';
            a.href = p.url;
            if (p.featured_image) {
              var img = document.createElement('img');
              img.className = 'dusa-rec__thumb';
              img.loading = 'lazy';
              img.width = 52;
              img.height = 52;
              img.alt = '';
              img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=120';
              a.appendChild(img);
            }
            var info = document.createElement('span');
            info.className = 'dusa-rec__info';
            var title = document.createElement('span');
            title.className = 'dusa-rec__title';
            title.textContent = p.title;
            var price = document.createElement('span');
            price.className = 'dusa-rec__price';
            price.textContent = money(p.price);
            info.appendChild(title);
            info.appendChild(price);
            a.appendChild(info);
            list.appendChild(a);
          });
        })
        .catch(function () {
          el.hidden = true;
        });
    });
  }

  function initAll(root) {
    initRecs(root);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAll(document);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var pending = null;
      new MutationObserver(function () {
        // Debounce: Dawn swaps large chunks of drawer HTML per cart update.
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () {
          initAll(drawer);
        }, 100);
      }).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
